import Database from 'database';
import { Queue, Impacto } from 'models';
import { Creators as queueCreators } from './queue';

export const Types = {
  GET_IMPACTOS: 'etapas/GET_IMPACTOS',
  GET_IMPACTOS_SUCCESS: 'etapas/GET_IMPACTOS_SUCCESS',
  GET_IMPACTOS_FAILED: 'etapas/GET_IMPACTOS_FAILED',
  UPDATE_IMPACTOS: 'etapas/UPDATE_IMPACTOS',
  UPDATE_IMPACTOS_SUCCESS: 'etapas/UPDATE_IMPACTOS_SUCCESS',
  UPDATE_IMPACTOS_FAILED: 'etapas/UPDATE_IMPACTOS_FAILED',
};

const initialState = {
  data: [],
  error: null,
  loading: false,
};

export default function impactosReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_IMPACTOS:
      return { ...state, loading: true };
    case Types.GET_IMPACTOS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload,
        pem: action.pem,
      };
    case Types.GET_IMPACTOS_FAILED:
      return { ...state, loading: false, error: action.payload };
    case Types.UPDATE_IMPACTOS:
      return { ...state, loading: true };
    case Types.UPDATE_IMPACTOS_SUCCESS:
      return { ...state, loading: false, error: null };
    case Types.UPDATE_IMPACTOS_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return { ...state };
  }
}

export const Creators = {
  getImpactos: (id, condition) => async dispatch => {
    dispatch({ type: Types.GET_IMPACTOS });
    try {
      const impactos = await Database.impactos
        .filter(
          impacto =>
            (condition ? condition(impacto) : true) &&
            (id ? String(impacto.pem_id) === String(id) : true),
        )
        .toArray();
      dispatch({
        type: Types.GET_IMPACTOS_SUCCESS,
        payload: impactos[0],
        pem: id,
      });
    } catch (oof) {
      console.error(oof.message);
      dispatch({
        type: Types.GET_IMPACTOS_FAILED,
        payload: { error: oof.message },
      });
    }
  },
  updateImpactos: (pemId, form) => async dispatch => {
    dispatch({ type: Types.UPDATE_IMPACTOS });
    try {
      try {
        const curb = await Database.impactos.filter(
          x => String(x.pem_id) === String(pemId),
        );
        await curb.delete();
        const x = {
          pem_id: pemId,
          produtividade: form.produtividade,
          classificacao: form.classificacao,
          porcentagem: {
            svb: Object.values(form.porcentagem.svb),
            convencional: Object.values(form.porcentagem.convencional),
          },
          preco: {
            svb: Object.values(form.preco.svb),
            convencional: Object.values(form.preco.convencional),
          },
        };
        const imp = new Impacto(x);
        await imp.save();
        const queue = new Queue({
          url: `impactos/${pemId}`,
          table: 'impactos',
          localId: imp._id,
          requestBody: {
            ...x,
            classificacao: form.classificacao,
            produtividade: Number(form.produtividade).toFixed(2),
            preco: Object.keys(form.preco).reduce(
              (res, key) => ({
                ...res,
                [key]: Object.values(form.preco[key]).map((v = 0) =>
                  Number(v).toFixed(2),
                ),
              }),
              {},
            ),
            porcentagem: Object.keys(form.porcentagem).reduce(
              (res, key) => ({
                ...res,
                [key]: Object.values(form.porcentagem[key]).map((v = 0) =>
                  Number(v).toFixed(2),
                ),
              }),
              {},
            ),
          },
        });
        await queue.save();
        dispatch(queueCreators.getQueue());
        dispatch({ type: Types.UPDATE_IMPACTOS_SUCCESS });
        dispatch(Creators.getImpactos(pemId));
      } catch (oof) {
        console.log(oof.message);
        dispatch({
          type: Types.UPDATE_IMPACTOS_FAILED,
          payload: { error: oof.message },
        });
      }
    } catch (oof) {
      console.error(oof.message);
      dispatch({
        type: Types.UPDATE_IMPACTOS_FAILED,
        payload: { error: oof.message },
      });
    }
  },
};
